
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'DocumentDiscussion',
  components: {},
  props: {
    previousTopicAvailable: {
      type: Boolean,
      default: false,
    },
    nextTopicAvailable: {
      type: Boolean,
      default: false,
    },
    canJumpToTop: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['previousTopic', 'nextTopic', 'listTopics', 'jumpToTop'],
  setup(props, context) {
    function showNext() {
      context.emit('nextTopic');
    }
    function showPrevious() {
      context.emit('previousTopic');
    }
    function showTopicList() {
      context.emit('listTopics');
    }
    function jumpToTop() {
      context.emit('jumpToTop');
    }
    return {
      showNext,
      showPrevious,
      showTopicList,
      jumpToTop,
    };
  },
});
